import { render, staticRenderFns } from "./hero.home.vue?vue&type=template&id=2e850d17&"
import script from "./hero.home.vue?vue&type=script&lang=js&"
export * from "./hero.home.vue?vue&type=script&lang=js&"
import style0 from "./hero.home.vue?vue&type=style&index=0&id=2e850d17&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports